/**
 * GMA-1869: `useFetch` seeds its data with `[]` (src/api/baseApi.js), so a
 * roster that has not loaded is indistinguishable from an empty one by
 * `Array.isArray` alone. Treat it as UNKNOWN until it has loaded AND has
 * entries — a user viewing a client necessarily has at least one, so an empty
 * roster here means "not loaded" or "request failed", never "no access to
 * anything". Returning undefined keeps the shared-contact delete modal
 * permissive and lets the server decide, instead of wrongly flagging every
 * linked client as unmanageable during the load window.
 *
 * @param {Array<{id: number}>|null|undefined} clients - roster from ClientContext
 * @param {boolean} loading - whether the roster request is in flight
 * @returns {Array<number>|undefined} client ids, or undefined when unknown
 */
export const deriveMyClientIds = (clients, loading) => {
  if (loading) return undefined;
  if (!Array.isArray(clients) || clients.length === 0) return undefined;
  return clients.map((c) => c.id);
};
